import { jsx as a } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import e from "classnames";
const f = d(
  ({ children: o, className: m, ...r }, t) => /* @__PURE__ */ a("div", { ref: t, className: e("modal_body", m), ...r, children: o })
);
f.displayName = "BottomSheetBody";
export {
  f as default
};
